import { httpRequest } from '../../../../core'
import { HttpMethod } from '../../../../core/type'
import { ChatRequest, ChatResponse, ExportResult, SavedReport, SavedReportRun } from '../type/ai-assistant'

export class AiAssistantService {
  /** Ask the reporting agent; the whole conversation is sent each time (no server session). */
  chat(request: ChatRequest): Promise<ChatResponse> {
    return httpRequest.execute<ChatResponse>({
      url: 'ai-reporting/chat',
      method: HttpMethod.POST,
      body: request,
    })
  }

  /** The full result behind an answer (the chat table shows at most 200 rows). */
  exportRows(queryLogId: number): Promise<ExportResult> {
    return httpRequest.execute<ExportResult>({
      url: `ai-reporting/queries/${queryLogId}/rows`,
      method: HttpMethod.GET,
    })
  }

  savedReports(): Promise<SavedReport[]> {
    return httpRequest.execute<SavedReport[]>({ url: 'ai-reporting/saved-reports', method: HttpMethod.GET })
  }

  /** Keep the query behind an answer; re-running it later costs nothing. */
  saveReport(queryLogId: number, name: string): Promise<SavedReport> {
    return httpRequest.execute<SavedReport>({
      url: 'ai-reporting/saved-reports',
      method: HttpMethod.POST,
      body: { queryLogId, name },
    })
  }

  runSavedReport(id: number): Promise<SavedReportRun> {
    return httpRequest.execute<SavedReportRun>({
      url: `ai-reporting/saved-reports/${id}/run`,
      method: HttpMethod.POST,
    })
  }

  deleteSavedReport(id: number): Promise<void> {
    return httpRequest.execute<void>({ url: `ai-reporting/saved-reports/${id}`, method: HttpMethod.DELETE })
  }
}
